import { render, staticRenderFns } from "./numbers-buy-page.vue?vue&type=template&id=b4c42b54&"
import script from "./numbers-buy-page.vue?vue&type=script&lang=js&"
export * from "./numbers-buy-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports